// Keep the Shop navigation pinned to Shopify's all-products collection,
// even if the Navigation menu in Shopify Admin still points at an old page.
document.addEventListener('click', function (event) {
  var link = event.target.closest('a');
  if (!link) return;

  var label = (link.textContent || '').trim().toLowerCase();
  if (label === 'webshop' || label === 'shop') {
    var target = '/collections/all';
    if (link.getAttribute('href') !== target) {
      event.preventDefault();
      window.location.assign(target);
    }
  }
}, true);

document.addEventListener('DOMContentLoaded', function () {
  var links = document.querySelectorAll('header a, .header a, .menu-drawer a');

  links.forEach(function (link) {
    var label = (link.textContent || '').trim().toLowerCase();

    if (label === 'webshop' || label === 'shop') {
      link.setAttribute('href', '/collections/all');
    }
  });

  var modal = document.getElementById('JArtworkRoomModal');
  if (!modal) {
    return;
  }

  var previousFocus = null;

  function openModal(trigger) {
    previousFocus = trigger || document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ja-room-modal-open');

    var closeButton = modal.querySelector('.ja-room-modal__close');
    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ja-room-modal-open');

    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-ja-room-open]');

    if (opener) {
      event.preventDefault();
      openModal(opener);
      return;
    }

    var closer = event.target.closest('[data-ja-room-close]');

    if (closer) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
});


// View in room frame color picker.
document.addEventListener('DOMContentLoaded', function () {
  var roomSection = document.getElementById('j-artwork-view-in-room');
  var roomModal = document.getElementById('JArtworkRoomModal');
  var selectedFrame = 'light-brown';

  function applyFrameColor(color) {
    selectedFrame = color;

    if (roomSection) {
      roomSection.setAttribute('data-ja-frame', color);
    }

    if (roomModal) {
      roomModal.setAttribute('data-ja-frame', color);
    }

    document.querySelectorAll('[data-ja-frame-color]').forEach(function (button) {
      var active = button.getAttribute('data-ja-frame-color') === color;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ja-frame-color]');
    if (!button) return;

    event.preventDefault();
    applyFrameColor(button.getAttribute('data-ja-frame-color'));
  });

  applyFrameColor(selectedFrame);
});

// Previous / next artwork navigation for View in Room.
// Load the complete All products collection through Shopify's storefront JSON
// endpoint instead of relying on collections['all'].products, which is limited
// to a partial slice when rendered through Liquid in this global snippet.
document.addEventListener('DOMContentLoaded', function () {
  var poolElement = document.getElementById('JArtworkRoomProductPool');

  var PRODUCT_RULES = {
    handles: ['gift-wrapping', 'gift-wrap', 'handwritten-message', 'handwritten-note', 'personal-message', 'artwork-frame', 'painting-frame', 'frame-option'],
    handleFragments: ['gift-voucher', 'gift_voucher', 'giftvoucher'],
    titleFragments: ['gift voucher', 'gift card', 'gift wrapping', 'gift wrap', 'handwritten message', 'personal message', 'artwork frame', 'painting frame', 'frame option', 'commission request'],
    typeFragments: ['service', 'voucher', 'gift card', 'add-on', 'addon', 'commission', 'frame option'],
    tagFragments: ['service', 'gift-wrap', 'gift_wrapping', 'handwritten-message', 'frame-option', 'addon', 'add-on', 'commission', 'gift-voucher', 'giftvoucher']
  };
  var SUPPORTING_IMAGE_FRAGMENTS = ['detail', 'close', 'certificate', 'thank you', 'thank-you', 'card', 'room', 'interior', 'lifestyle', 'packing', 'frame corner'];

  function normalizeString(value) {
    return String(value || '').trim().toLowerCase();
  }

  function listify(value) {
    if (Array.isArray(value)) return value.map(String);
    return String(value || '').split('|').filter(Boolean);
  }

  function includesAny(value, values) {
    return values.some(function (entry) { return value.indexOf(entry) !== -1; });
  }

  function isExcludedRoomProduct(item) {
    if (!item) return true;
    if (String(item.eligibleArtwork || '').toLowerCase() === 'true') return false;
    if (String(item.eligibleArtwork || '').toLowerCase() === 'false') return true;

    var handle = normalizeString(item.handle || (String(item.url || '').match(/\/products\/([^/?#]+)/i) || [, ''])[1]);
    var title = normalizeString(item.title);
    var type = normalizeString(item.productType || item.type);
    var tags = listify(item.tags).map(normalizeString).join('|');

    if (PRODUCT_RULES.handles.indexOf(handle) !== -1) return true;
    if (includesAny(handle, PRODUCT_RULES.handleFragments)) return true;
    if (includesAny(title, PRODUCT_RULES.titleFragments)) return true;
    if (includesAny(type, PRODUCT_RULES.typeFragments)) return true;
    if (includesAny(tags, PRODUCT_RULES.tagFragments)) return true;
    return false;
  }

  function fallbackProducts() {
    if (!poolElement) return [];
    try {
      return JSON.parse(poolElement.textContent || '[]').filter(function (item) {
        return item && item.handle && item.image && !isExcludedRoomProduct(item);
      });
    } catch (error) {
      return [];
    }
  }

  function storefrontRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function numericRatio(value) {
    var ratio = Number(value);
    return Number.isFinite(ratio) && ratio > 0 ? ratio : null;
  }

  function numericDimension(value) {
    var dimension = Number(value);
    return Number.isFinite(dimension) && dimension > 0 ? dimension : null;
  }

  function imageRatioFromObject(image) {
    if (!image || typeof image !== 'object') return null;
    var direct = numericRatio(image.aspect_ratio || image.aspectRatio || image.ratio);
    if (direct) return direct;
    var width = Number(image.width);
    var height = Number(image.height);
    return Number.isFinite(width) && Number.isFinite(height) && width > 0 && height > 0 ? width / height : null;
  }

  function orientationFromRatio(ratio) {
    var value = numericRatio(ratio) || 0.8;
    if (value > 1.08) return 'landscape';
    if (value >= 0.92) return 'square';
    return 'portrait';
  }

  function imageSrcFromObject(image) {
    if (!image) return null;
    return typeof image === 'string' ? image : (image.src || image.url || null);
  }

  function isSupportingImage(image, fallbackTitle) {
    if (!image) return false;
    var alt = normalizeString((typeof image === 'object' && image.alt) || fallbackTitle || '');
    var src = normalizeString(imageSrcFromObject(image));
    return SUPPORTING_IMAGE_FRAGMENTS.some(function (fragment) {
      return alt.indexOf(fragment) !== -1 || src.indexOf(fragment) !== -1;
    });
  }

  function pickPreferredImage(product) {
    if (!product) return null;
    var featured = product.featured_image || product.featuredImage || null;
    var images = Array.isArray(product.images) ? product.images : [];
    if (featured && !isSupportingImage(featured, product.title)) return featured;
    for (var i = 0; i < images.length; i += 1) {
      if (!isSupportingImage(images[i], product.title)) return images[i];
    }
    return featured || images[0] || null;
  }

  function normalizeApiProduct(product) {
    if (!product || !product.handle || isExcludedRoomProduct(product)) return null;

    var preferredImage = pickPreferredImage(product);
    var image = imageSrcFromObject(preferredImage);
    var alt = (preferredImage && preferredImage.alt) || product.title || 'Artwork';
    var ratio = imageRatioFromObject(preferredImage) || numericRatio(product.aspect_ratio || product.aspectRatio);

    if (!image) return null;

    var available = typeof product.available === 'boolean'
      ? product.available
      : (Array.isArray(product.variants) ? product.variants.some(function (variant) { return variant && variant.available; }) : true);

    var widthCm = numericDimension(product.widthCm || product.width_cm);
    var heightCm = numericDimension(product.heightCm || product.height_cm);
    if (widthCm && heightCm) ratio = widthCm / heightCm;

    return {
      handle: product.handle,
      title: product.title || 'Artwork',
      url: product.url || (storefrontRoot() + 'products/' + product.handle),
      image: image,
      alt: alt,
      ratio: ratio,
      widthCm: widthCm,
      heightCm: heightCm,
      orientation: orientationFromRatio(ratio),
      available: available,
      tags: product.tags || [],
      productType: product.type || product.productType || '',
      eligibleArtwork: 'true'
    };
  }

  async function loadAllProducts() {
    var all = [];
    var seen = new Set();
    var page = 1;
    var limit = 250;

    while (page <= 20) {
      var endpoint = storefrontRoot() + 'collections/all/products.json?limit=' + limit + '&page=' + page;
      var response = await fetch(endpoint, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Unable to load product catalog');

      var payload = await response.json();
      var batch = Array.isArray(payload.products) ? payload.products : [];

      batch.forEach(function (product) {
        var item = normalizeApiProduct(product);
        if (item && !seen.has(item.handle)) {
          seen.add(item.handle);
          all.push(item);
        }
      });

      if (batch.length < limit) break;
      page += 1;
    }

    return all;
  }

  var roomRoots = Array.from(document.querySelectorAll('#j-artwork-view-in-room, #JArtworkRoomModal'));
  if (!roomRoots.length) return;

  var products = fallbackProducts().map(function (item) {
    item.widthCm = numericDimension(item.widthCm);
    item.heightCm = numericDimension(item.heightCm);
    if (item.widthCm && item.heightCm) item.ratio = item.widthCm / item.heightCm;
    item.ratio = numericRatio(item.ratio);
    item.orientation = orientationFromRatio(item.ratio);
    item.eligibleArtwork = 'true';
    return item;
  });
  var liquidGeometryByHandle = new Map(products.map(function (item) {
    return [item.handle, { widthCm: item.widthCm, heightCm: item.heightCm, ratio: item.ratio }];
  }));
  var geometryRequests = new Map();
  var transitioning = false;
  var transitionTimer = null;

  function currentProductHandleFromUrl() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return match && match[1] ? decodeURIComponent(match[1]) : '';
  }

  var roomHandle = (document.getElementById('JArtworkRoomModal') || roomRoots[0]).getAttribute('data-ja-room-product-handle') || '';
  var selectedHandle = currentProductHandleFromUrl() || roomHandle;
  var selectedIndex = 0;
  var hasSelectedIndex = false;

  function normalizeIndex(index) {
    return products.length ? (index % products.length + products.length) % products.length : 0;
  }

  function syncSelectedIndexFromHandle(handle) {
    if (!products.length) {
      selectedIndex = 0;
      hasSelectedIndex = false;
      return false;
    }
    var found = products.findIndex(function (item) { return item.handle === handle; });
    if (found >= 0) {
      selectedIndex = found;
      hasSelectedIndex = true;
      return true;
    }
    hasSelectedIndex = false;
    return false;
  }

  function updateButtons(forceDisabled) {
    roomRoots.forEach(function (root) {
      root.querySelectorAll('[data-ja-room-product-prev], [data-ja-room-product-next]').forEach(function (button) {
        button.disabled = Boolean(forceDisabled) || products.length < 2;
      });
    });
  }

  function formatDimensionValue(value) {
    var number = numericDimension(value);
    if (!number) return null;
    return Number.isInteger(number) ? String(number) : String(Number(number.toFixed(1)));
  }

  function dimensionsLabel(widthCm, heightCm) {
    var width = formatDimensionValue(widthCm);
    var height = formatDimensionValue(heightCm);
    return width && height ? (width + ' × ' + height + ' cm') : 'Scale estimated from artwork proportions';
  }

  function estimatedScaleWidthPercent(ratio) {
    var safeRatio = numericRatio(ratio) || 0.8;
    if (safeRatio > 1.08) return Math.min(44, Math.max(31, 34 + (safeRatio - 1) * 6));
    if (safeRatio >= 0.92) return 31;
    return 27;
  }

  function roomScalePercent(root, widthCm, heightCm, ratio) {
    var width = numericDimension(widthCm);
    var height = numericDimension(heightCm);
    var safeRatio = numericRatio(ratio) || 0.8;

    if (!width && height && safeRatio) width = height * safeRatio;
    if (!height && width && safeRatio) height = width / safeRatio;
    if (!width || !height) return estimatedScaleWidthPercent(safeRatio);

    var referenceWidth = numericDimension(root.getAttribute('data-ja-room-reference-width-cm')) || 180;
    var referenceHeight = numericDimension(root.getAttribute('data-ja-room-reference-height-cm')) || 187;
    var widthPct = width / referenceWidth * 100;
    var heightPct = height / referenceHeight * 100;
    var fit = Math.min(1, 92 / widthPct, 90 / heightPct);
    return Math.max(1, widthPct * fit);
  }

  function applyRoomGeometry(root, item) {
    var art = root.querySelector('[data-ja-room-art], .ja-room-scene__art');
    if (!art || !item) return;

    var width = numericDimension(item.widthCm);
    var height = numericDimension(item.heightCm);
    var dimensionRatio = width && height ? width / height : null;
    var safeRatio = dimensionRatio || numericRatio(item.ratio) || 0.8;
    var safeOrientation = orientationFromRatio(safeRatio);
    var scaleWidth = roomScalePercent(root, width, height, safeRatio);
    var measured = Boolean(width && height);

    art.style.setProperty('--ja-art-ratio', String(safeRatio));
    if (scaleWidth) {
      art.style.setProperty('--ja-art-scale-w', Number(scaleWidth).toFixed(3) + '%');
    } else {
      art.style.removeProperty('--ja-art-scale-w');
    }

    if (measured) art.setAttribute('data-ja-physical-scale', 'true');
    else art.removeAttribute('data-ja-physical-scale');

    art.setAttribute('data-ja-orientation', safeOrientation);
    art.setAttribute('data-ja-scale-mode', measured ? 'measured' : 'estimated');
    if (width) art.setAttribute('data-ja-art-width-cm', String(width));
    else art.removeAttribute('data-ja-art-width-cm');
    if (height) art.setAttribute('data-ja-art-height-cm', String(height));
    else art.removeAttribute('data-ja-art-height-cm');
    root.setAttribute('data-ja-room-orientation', safeOrientation);
    root.setAttribute('data-ja-room-scale-mode', measured ? 'measured' : 'estimated');
  }

  function setRoomCopy(root, item) {
    var title = root.querySelector('.ja-room-modal__head h2, .ja-room-section__head h2');
    if (title) title.textContent = item.title || 'Artwork preview';

    var openLink = root.querySelector('.ja-room-modal__head a');
    if (openLink) openLink.setAttribute('href', item.url);

    var availability = root.querySelector('[data-ja-room-availability]');
    if (availability) {
      var isAvailable = item.available !== false;
      availability.textContent = isAvailable ? 'AVAILABLE' : 'SOLD';
      availability.classList.toggle('is-collected', !isAvailable);
    }

    var dimensions = root.querySelector('[data-ja-room-dimensions]');
    if (dimensions) dimensions.textContent = dimensionsLabel(item.widthCm, item.heightCm);
  }

  function responsiveRoomUrl(src, width) {
    var url = new URL(src, window.location.origin);
    url.searchParams.set('width', String(width));
    return url.href;
  }

  function setResponsiveRoomImage(image, src) {
    var widths = [160, 240, 320, 480, 640, 960, 1200];
    image.sizes = 'auto, (max-width: 749px) 45vw, 28vw';
    image.srcset = widths.map(function (width) {
      return responsiveRoomUrl(src, width) + ' ' + width + 'w';
    }).join(', ');
    image.src = responsiveRoomUrl(src, 640);
  }

  function preloadImage(src) {
    return new Promise(function (resolve) {
      if (!src) {
        resolve();
        return;
      }
      var img = new Image();
      img.onload = img.onerror = function () { resolve(); };
      img.src = src;
    });
  }

  function delay(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function clearTransitionClasses() {
    roomRoots.forEach(function (root) {
      root.classList.remove('is-room-switching-out');
      root.classList.remove('is-room-switching-in');
    });
  }

  function hydrateProductGeometry(item) {
    if (!item || !item.handle || (item.widthCm && item.heightCm)) return Promise.resolve(item);

    var liquidGeometry = liquidGeometryByHandle.get(item.handle);
    if (liquidGeometry && liquidGeometry.widthCm && liquidGeometry.heightCm) {
      item.widthCm = liquidGeometry.widthCm;
      item.heightCm = liquidGeometry.heightCm;
      item.ratio = item.widthCm / item.heightCm;
      item.orientation = orientationFromRatio(item.ratio);
      return Promise.resolve(item);
    }

    if (geometryRequests.has(item.handle)) return geometryRequests.get(item.handle);

    var request = fetch(item.url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load artwork dimensions');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var art = doc.querySelector('#JArtworkRoomModal [data-ja-room-art], #j-artwork-view-in-room [data-ja-room-art]');
        if (art) {
          var width = numericDimension(art.getAttribute('data-ja-art-width-cm'));
          var height = numericDimension(art.getAttribute('data-ja-art-height-cm'));
          if (width && height) {
            item.widthCm = width;
            item.heightCm = height;
            item.ratio = width / height;
            item.orientation = orientationFromRatio(item.ratio);
            liquidGeometryByHandle.set(item.handle, { widthCm: width, heightCm: height, ratio: item.ratio });
          }
        }

        if (!item.image) {
          var image = doc.querySelector('#JArtworkRoomModal .ja-room-scene__art-image, #j-artwork-view-in-room .ja-room-scene__art-image');
          if (image) item.image = image.currentSrc || image.getAttribute('src') || item.image;
        }
        return item;
      })
      .catch(function () { return item; });

    geometryRequests.set(item.handle, request);
    return request;
  }

  function commitProduct(index) {
    if (!products.length) {
      updateButtons();
      return;
    }

    selectedIndex = normalizeIndex(index);
    var item = products[selectedIndex];
    selectedHandle = item.handle;

    roomRoots.forEach(function (root) {
      root.setAttribute('data-ja-room-product-handle', item.handle);
      applyRoomGeometry(root, item);
      setRoomCopy(root, item);

      var image = root.querySelector('.ja-room-scene__art-image');
      if (image) {
        image.alt = item.alt || item.title || 'Artwork';

        var syncNaturalRatio = function () {
          if (!image.naturalWidth || !image.naturalHeight) return;
          var naturalRatio = image.naturalWidth / image.naturalHeight;
          if (!item.ratio) {
            item.ratio = naturalRatio;
            item.orientation = orientationFromRatio(naturalRatio);
          }
          if (!item.widthCm || !item.heightCm) {
            roomRoots.forEach(function (roomRoot) {
              if (roomRoot.getAttribute('data-ja-room-product-handle') === item.handle) {
                applyRoomGeometry(roomRoot, item);
                setRoomCopy(roomRoot, item);
              }
            });
          }
        };

        image.onload = syncNaturalRatio;
        setResponsiveRoomImage(image, item.image);
        if (image.complete) syncNaturalRatio();
      }
    });

    if (!item.widthCm || !item.heightCm) {
      hydrateProductGeometry(item).then(function (hydrated) {
        if (selectedHandle !== hydrated.handle) return;
        roomRoots.forEach(function (root) {
          if (root.getAttribute('data-ja-room-product-handle') === hydrated.handle) {
            applyRoomGeometry(root, hydrated);
            setRoomCopy(root, hydrated);
          }
        });
      });
    }

    updateButtons();
  }

  async function transitionToIndex(index) {
    if (!products.length) {
      updateButtons();
      return;
    }
    if (transitioning) return;

    transitioning = true;
    updateButtons(true);
    clearTimeout(transitionTimer);

    var target = products[normalizeIndex(index)];
    roomRoots.forEach(function (root) {
      root.classList.remove('is-room-switching-in');
      root.classList.add('is-room-switching-out');
    });

    await Promise.all([preloadImage(target && target.image ? responsiveRoomUrl(target.image, 640) : null), delay(90)]);
    commitProduct(index);
    roomRoots.forEach(function (root) {
      root.classList.remove('is-room-switching-out');
      root.classList.add('is-room-switching-in');
    });

    transitionTimer = setTimeout(function () {
      clearTransitionClasses();
      transitioning = false;
      updateButtons();
    }, 220);
  }

  document.addEventListener('click', function (event) {
    var previous = event.target.closest('[data-ja-room-product-prev]');
    var next = event.target.closest('[data-ja-room-product-next]');
    if (!previous && !next) return;

    event.preventDefault();
    transitionToIndex(selectedIndex + (next ? 1 : -1));
  });

  if (syncSelectedIndexFromHandle(selectedHandle)) {
    commitProduct(selectedIndex);
  } else {
    updateButtons();
  }

  loadAllProducts().then(function (fullCatalog) {
    if (!fullCatalog.length) return;
    fullCatalog.forEach(function (item) {
      var geometry = liquidGeometryByHandle.get(item.handle);
      if (geometry) {
        item.widthCm = geometry.widthCm || item.widthCm;
        item.heightCm = geometry.heightCm || item.heightCm;
        if (item.widthCm && item.heightCm) item.ratio = item.widthCm / item.heightCm;
        item.orientation = orientationFromRatio(item.ratio);
      }
    });
    products = fullCatalog;

    var pageHandle = currentProductHandleFromUrl();
    if (pageHandle) selectedHandle = pageHandle;

    if (syncSelectedIndexFromHandle(selectedHandle)) {
      commitProduct(selectedIndex);
    } else {
      updateButtons();
    }
  }).catch(function () {
    updateButtons();
  });
});

// Open View in Room automatically when arriving from Spotlight.
document.addEventListener('DOMContentLoaded', function () {
  var params = new URLSearchParams(window.location.search);
  if (params.get('view_room') !== '1') return;

  var opener = document.querySelector('[data-ja-room-open]');
  if (opener) opener.click();
});

(function () {
  function polishShippingBadge() {
    document.querySelectorAll('.shopify-app-block #text_container').forEach(function (container) {
      var title = container.querySelector('#title');
      var subtitle = container.querySelector('#subheading');
      if (title && title.textContent.trim() === 'Free Shipping') title.textContent = 'Free shipping';
      if (subtitle && subtitle.textContent.trim() === 'Delivered to Your doorstep, on us!') subtitle.textContent = 'Delivered to your doorstep, on us.';
    });
  }
  function startShippingPolish() {
    polishShippingBadge();
    new MutationObserver(polishShippingBadge).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startShippingPolish);
  else startShippingPolish();
})();
